module.exports = __webpack_public_path__ + "img/table_three.cdb50c1c.svg";